import DrinksPage from "./DrinksPage";

export default DrinksPage;
